import { POSITION_TO_NUMBER } from '@/constants';

/**
 * Конвертирует строковое представление позиции в числовое значение
 * @param position - Позиция игрока ('GK', 'DEF', 'MID', 'FWD')
 * @returns Числовое значение позиции (1-4) или 0 если позиция неизвестна
 */
export function positionStringToNumber(position: string): number {
  return POSITION_TO_NUMBER[position] || 0;
}
